import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { setIssuePanelRatio } from '../../../state/settings/actions.tsx';
import { getIssuePanelRatio } from '../../../state/settings/selectors.tsx';
import type { State } from '../../../state/types.tsx';
import { RoadmapPanel } from './view.tsx';

export default connect((state: State) => ({ issuePanelRatio: getIssuePanelRatio(state) }), {
	setIssuePanelRatio,
})(RoadmapPanel);
